// ------------------------------------
// Cria um pedido
// ------------------------------------

// Variáveis
const $form = $('#form-checkout');
const urlOrder = urlBase + 'core/acoes/checkout/order.php';
const type = $form.attr('method');
let data;
let reqAjaxSave = null;
let orderSubmitting = false;

$form.on('submit', function (ev) {
  ev.preventDefault();
  if (previewMode) return;
  if (orderSubmitting) return;

  if (!$('.payment-item input[name="payment_method"]:checked').val()) {
    showAlert('Atenção!', 'Escolha uma forma de pagamento para continuar.', 'warning');
    return;
  }

  const method = $('.payment-item input[name="payment_method"]:checked').val();
  const isCard = method === 'credit_card' || method === 'cartao' || method === 'card';

  orderSubmitting = true;
  disableOrderBtn();
  showLoader('Por favor, aguarde...', 'Validando dados do pedido...');

  let cardPromise = Promise.resolve({ skipped: true });

  if (isCard) {
    if (!window.LPQV?.payments?.generateCardToken) {
      hideLoader();
      enableOrderBtn();
      orderSubmitting = false;
      showAlert('Erro', 'Módulo de pagamento não carregado. Recarregue a página e tente novamente.', 'danger');
      return;
    }

    $('#co-card-hash').val('');
    cardPromise = window.LPQV.payments.generateCardToken();
  }

  cardPromise
    .then(() => {
      return generateRecaptchaToken();
    })
    .then(() => {
      return orderCreate();
    })
    .catch((err) => {
      hideLoader();
      enableOrderBtn();
      orderSubmitting = false;
      showAlert('Erro', err.message || 'Não foi possível validar o pedido.', 'danger');
    });
});

// Salva o checkout
function orderCreate() {
  if (window.LpqvTracking) {
    // Atualiza o hidden 'extra_infos' com fbc/fbp/click-ids atuais (lidos do cookie
    // agora, no momento real do envio) antes de montar o FormData — fica persistido
    // em orders.extra pra um eventual disparo assíncrono via webhook (Pix/boleto
    // confirmados depois, sem o cliente na aba) usar os identificadores corretos.
    window.LpqvTracking.refreshExtraInfos();
  }
  data = new FormData($form[0]);
  data.append('acao', 'save');

  // Correção para impedir que finalize sem a forma de envio
  if ($('.shipping_ways').length) {
    let curShippingWay = $('.shipping_ways input:checked').val();
    if (!curShippingWay && (getOption('shipping_way') || $('.shipping_ways').data('value'))) {
      curShippingWay = getOption('shipping_way') || $('.shipping_ways').data('value');
      data.append('shipping_way', curShippingWay);
    }
  }

  if (reqAjaxSave != null) {
    reqAjaxSave.abort();
  }

  showLoader('Por favor, aguarde...', 'Estamos processando o seu pedido.<br> Não feche esta página.');

  reqAjaxSave = $.ajax({
    url: urlOrder,
    type: type,
    data: data,
    contentType: false,
    cache: false,
    processData: false,
  });

  return reqAjaxSave
    .done(function (result) {
      console.log(result);
      result = JSON.parse(result);

      if (result.status === 'success') {
        try {
          sessionStorage.removeItem('checkout_infos_' + cartToken);
        } catch (e) {
          console.log('sessionStorage indisponível para limpar checkout-infos.');
        }
        location.href = result.payment_url;
      } else if (result.status === 'error') {
        if (result.type === 'no_ship' && $('.shipping_ways input:checked').length > 0) {
          $('.shipping_ways input:checked').trigger('trigger-ship');
        }
        enableOrderBtn();
        hideLoader();
        orderSubmitting = false;
        showAlert('Erro', result.message, 'danger');
      } else {
        enableOrderBtn();
        hideLoader();
        orderSubmitting = false;
        showAlert('Erro', 'Não foi possível criar o pedido.', 'danger');
      }
    })
    .fail(function (xhr, status, exception) {
      console.log(exception);
      console.log('Não foi possível criar o pedido.');
      $.ajax({
        url: urlBase + 'core/acoes/checkout/grava_log.php',
        type: 'POST',
        data: {
          store_token: storeToken,
          category: 'order-ajax-fail',
          status: xhr.status,
          status_text: xhr.statusText,
          response: (xhr.responseText || '').substring(0, 500),
          js_status: status,
          url: urlOrder,
        },
      });
      hideLoader();
      enableOrderBtn();
      orderSubmitting = false;
    });
}

// RECAPTCHA
function generateRecaptchaToken() {
  const recaptchaAction = 'submit_checkout';
  if (!recaptchaEnabled) {
    return Promise.resolve({ skipped: true, disabled: true });
  }
  if (!recaptchaSitekey) {
    return Promise.reject(new Error('reCAPTCHA não configurado.'));
  }
  if (typeof grecaptcha === 'undefined') {
    return Promise.reject(new Error('reCAPTCHA não carregado.'));
  }
  return new Promise((resolve, reject) => {
    grecaptcha.ready(function () {
      grecaptcha
        .execute(recaptchaSitekey, { action: recaptchaAction })
        .then(function (token) {
          if (!token) {
            return reject(new Error('Token do reCAPTCHA não retornado.'));
          }
          $('#co-recaptcha-token').val(token);
          resolve({ token: token, action: recaptchaAction });
        })
        .catch(function () {
          reject(new Error('Não foi possível gerar o token do reCAPTCHA.'));
        });
    });
  });
}
